/**
 * Human-readable labels for technical codes (project rule: raw codes like
 * "invoice.posted" or "totalAmount" must never reach the UI). Unknown codes
 * fall back to the raw value so nothing breaks when new events appear.
 */
export function eventLabel(t, topic) {
  if (!topic) return '';
  const key = `event.${topic}`;
  const label = t(key);
  return label === key ? topic : label;
}

export function fieldLabel(t, field) {
  if (!field) return '';
  const key = `field.${field}`;
  const label = t(key);
  return label === key ? field : label;
}
